import React from "react";
import { IconBaseProps, IconType } from "react-icons/lib";
import classes from "./CardIcon.module.css"

const CardIcon = (props: cardIconsProps) => {
    const TheIcon = props.icon;
    return (
        <div className={classes.card}>
            <div className={classes.body}>
                <div className={classes.icon} style={{backgroundColor: props.iconColor}}>
                    <TheIcon />
                </div>
                <div className={classes.title}>
                    {props.title}
                </div>
                <div className={`fw-bold ${classes.value}`}>
                    {props.value}
                </div>
            </div>
            <div className={classes.footer}>
                {props.footer}
            </div>
        </div>
    )
}

export default CardIcon

interface cardIconsProps{
    title: string;
    value: string;
    icon: any;
    iconColor: string;
    footer: string;
}